import LoadCard from "./LoadCard";

export default LoadCard;